<template>

  <FatturazioneView />

</template>

<script>
import FatturazioneView from '../components/fatturazione/FatturazioneView.vue'

export default {
  pageName: 'FatturazioneView',
  components: {
    FatturazioneView

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
